import { labelDefaultSemiboldStyles } from '@lifebit-ai/lds'
import styled from 'styled-components'

export const AdvancedQueryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const FiltersViewWrapper = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  overflow: scroll;
  max-width: 100%;

  > div {
    overflow: visible;
  }
`

export const FilterWrapper = styled.div`
  border-radius: ${({ theme }) => theme.size.border.radius['03']};
  border: 1px solid ${({ theme }) => theme.color.border.subtle};
  width: 100%;
  overflow: hidden;
`

export const TableName = styled.div`
  padding: ${({ theme }) => theme.size.space['03']};
  background-color: ${({ theme }) => theme.color.background.highlight};
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.color.chart['03']};
  ${labelDefaultSemiboldStyles};
  font-size: ${({ theme }) => theme.font.label.fontSize.small};
  text-transform: uppercase;
`
